import React, { useCallback, useMemo } from 'react';
import noop from 'lodash/noop';

import { setIn } from '@lyearn/core/utils/immutable';
import { useTranslation } from '@lyearn/i18n';
import Form from '@/components/Form';

import { FieldSettingsProps } from './types';

function FieldSettings(props: FieldSettingsProps) {
  const { t } = useTranslation();
  const { allowPartialUpdates, onChange: onChangeProp, field } = props;
  const { config, viewField, metadataField } = field;
  const { getFieldSettingsFormProps, getFieldSettingsFormInitialValues } = config.Editor;

  const formProps = useMemo(
    () => getFieldSettingsFormProps({ t, allowPartialUpdates }),
    [allowPartialUpdates, getFieldSettingsFormProps, t],
  );

  const onChange = useCallback(
    (response: any) => {
      const required = !response.values.viewField.required;
      const descriptionEnabled = response.values.viewField.descriptionEnabled;
      let updates = setIn(response.values, 'viewField.required', required);

      if (!descriptionEnabled) {
        updates = setIn(updates, 'viewField.description', null);
      }

      onChangeProp({ fieldId: viewField.fieldId, updates });
    },
    [onChangeProp, viewField.fieldId],
  );

  // required is negated, as we are showing in UI as optional
  const initialValues = useMemo(() => {
    let fieldInitialValues = getFieldSettingsFormInitialValues({ viewField, metadataField });
    fieldInitialValues = setIn(fieldInitialValues, 'viewField.required', !viewField.required);

    return fieldInitialValues;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form
      formName={viewField.fieldId}
      initialValues={initialValues}
      onChange={onChange}
      onSubmit={noop}
      {...formProps}
    />
  );
}

export default FieldSettings;
